import React, { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Text,
  useToast,
  FormControl,
  FormLabel,
  Link,
  InputGroup,
  InputLeftElement,
  Container,
  VStack,
  useColorModeValue
} from '@chakra-ui/react';
import { EmailIcon } from '@chakra-ui/icons';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axiosInstance from '../services/axiosInstance';
// Chakra UI components
import { HStack, Image, Grid, Icon, Divider } from '@chakra-ui/react';

// React Icons
import { FaSignInAlt, FaPhone } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import Footer from '../layout/Footer';
import Header from '../layout/Header';

// Header Component




const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  // Colors
  const primaryColor = '#F2C919';
  const secondaryColor = '#2C3E50';
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const cardBg = useColorModeValue('white', 'gray.800');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await axiosInstance.post('/auth/forgot-password', { email });
      toast({
        title: 'تم إرسال البريد الإلكتروني',
        description: 'تم إرسال كلمة المرور وقتية إلى عنوان بريدك الإلكتروني',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top'
      });
      navigate('/login');
    } catch (error) {
      toast({
        title: 'خطأ',
        description: error.response?.data?.message || "حدث خطأ ما",
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box minH="100vh" display="flex" flexDirection="column" dir="rtl">
      <Header />

      <Flex 
        flex="1" 
        bg={bgColor}
        align="center" 
        justify="center"
        py={12}
        px={4}
      >
        <Box
          w="full"
          maxW="md"
          bg={cardBg}
          p={8}
          borderRadius="xl"
          boxShadow="xl"
          borderTop={`4px solid ${primaryColor}`}
        >
          <VStack spacing={6} align="stretch">
            <Box textAlign="center">
              <Heading size="lg" mb={2} color={secondaryColor}>
                نسيت كلمة المرور
              </Heading>
              <Text color="gray.600">
                 أدخل عنوان بريدك الإلكتروني لتلقي  كلمة المرور
              </Text>
            </Box>
            
            <form onSubmit={handleSubmit}>
              <FormControl mb={6}>
                <FormLabel color={secondaryColor}>البريد الإلكتروني</FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <EmailIcon color="gray.400" />
                  </InputLeftElement>
                  <Input
                    type="email"
                    placeholder="بريدك الإلكتروني"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    focusBorderColor={primaryColor}
                    required
                    size="lg"
                  />
                </InputGroup>
              </FormControl>

              <Button
                type="submit"
                bg={primaryColor}
                color={secondaryColor}
                _hover={{ bg: '#E5B817' }}
                size="lg"
                width="full"
                isLoading={isLoading}
                loadingText="جاري الإرسال"
              >
                إرسال الرابط
              </Button>
            </form>

            <Text mt={4} textAlign="center">
              <Link 
                as={RouterLink} 
                to="/login" 
                color={secondaryColor}
                fontWeight="medium"
                _hover={{ color: primaryColor, textDecoration: 'underline' }}
              >
                العودة إلى تسجيل الدخول
              </Link>
            </Text>
          </VStack>
        </Box>
      </Flex>

      <Footer />
    </Box>
  );
};

export default ForgotPasswordPage;


